"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return MessageTypes;
    }
});
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
var MessageTypes = function MessageTypes() {
    "use strict";
    _classCallCheck(this, MessageTypes);
    throw new Error("Static Class");
};
MessageTypes.GQL_CONNECTION_INIT = "connection_init" // Client -> Server
;
MessageTypes.GQL_CONNECTION_ACK = "connection_ack" // Server -> Client
;
MessageTypes.GQL_CONNECTION_ERROR = "connection_error" // Server -> Client
;
// NOTE: The keep alive message type does not follow the standard due to connection optimizations
MessageTypes.GQL_CONNECTION_KEEP_ALIVE = "ka" // Server -> Client
;
// Subscription acknowledgment message: After sending the subscription start message, the client should wait for AWS AppSync to send the start_ack message. The start_ack message indicates that the subscription is successful.
MessageTypes.GQL_CONNECTION_START_ACK = "start_ack" // Server -> Client
;
MessageTypes.GQL_CONNECTION_TERMINATE = "connection_terminate" // Client -> Server
;
MessageTypes.GQL_START = "start" // Client -> Server
;
MessageTypes.GQL_DATA = "data" // Server -> Client
;
MessageTypes.GQL_ERROR = "error" // Server -> Client
;
MessageTypes.GQL_COMPLETE = "complete" // Server -> Client
;
MessageTypes.GQL_STOP = "stop" // Client -> Server
;

//# sourceMappingURL=message-types.js.map